import { useState } from 'react';
import '../index.css'
import './OSA.css'
import AlertModal from '../components/AlertModal';
import Spacer from '../components/Spacer.js'

function OSA() {
    const defaultFormData = { firstname: '', surname: '', email: '', bus: false, allergies: '', coming: true }

    const [formData, setFormData] = useState(defaultFormData);
    const [submittedData, setSubmittedData] = useState(null);
    const [errors, setErrors] = useState({});
    const [showErrorAlert, setShowErrorAlert] = useState(false);
    const [showAlert, setShowAlert] = useState(false);

    const validate = () => {
        const errors = {};
        if (!formData.firstname.trim()) {
            errors.firstname = 'Får ej vara tom!';
        }
        if (!formData.surname.trim()) {
            errors.surname = 'Får ej vara tom!';
        }
        if (!/^\S+@\S+\.\S+$/.test(formData.email)) {
            errors.email = 'Fel format på email!';
        }
        return errors;
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: value
        }));
    };

    const handleFirstButtonClick = () => {
        setFormData(prev => ({
            ...prev,
            coming: true
        }));
    }

    const handleSecondButtonClick = () => {
        setFormData(prev => ({
            ...prev,
            coming: false
        }));
    }

    const handleSubmit = async (e) => {
        e.preventDefault();
        const validationErrors = validate();
        if (Object.keys(validationErrors).length > 0) {
            setErrors(validationErrors);
            return;
        }

        setErrors({});

        const dataToSubmit = { ...formData };

        const res = await fetch('/api/submit', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(formData),
        });

        const result = await res.json();

        if (result.error) {
            setShowErrorAlert(true);
            return;
        }

        setSubmittedData(dataToSubmit);
        setShowAlert(true);
        setFormData(defaultFormData);
    }

    return (
        <div className='home-main'>
            <h1 className='home-main-text'>OSA</h1>
            <Spacer />
            <div className='form-outer-container'>
                <div className='form-container'>
                    <div className='inner-form-container'>
                        <div className='form-text'>
                            Vi ser verkligen fram emot att fira tillsammans med er!
                            Var vänlig meddela om ni kan komma i formuläret senast den 15/05-2027.
                            Vill ni anmäla ett sällskap så går det bra att skicka in flera gånger, en gång per person.
                        </div>
                        <Spacer />
                        <div className='form-text'>
                            Observera att inbjudan är personlig. Om ni önskar ta med en plus one, vänligen stäm först av med brudparet.
                        </div>
                        <Spacer />
                        <form onSubmit={handleSubmit} className="input-grid">
                            <div>
                                <div className='form-text'>Förnamn</div>
                                <input className='osa-input' type="text" name="firstname" value={formData.firstname} onChange={handleChange} />
                                {errors.firstname && <span className='form-text error-text'>{errors.firstname}</span>}
                            </div>
                            <div>
                                <div className='form-text'>Efternamn</div>
                                <input className='osa-input' type="text" name="surname" value={formData.surname} onChange={handleChange} />
                                {errors.surname && <span className='form-text error-text'>{errors.surname}</span>}
                            </div>
                            <div>
                                <div className='form-text'>Email</div>
                                <input className='osa-input' type="text" name="email" value={formData.email} onChange={handleChange} />
                                {errors.email && <span className='form-text error-text'>{errors.email}</span>}
                            </div>
                            <div>
                                <div className='form-text'>Allergier</div>
                                <input className='osa-input' type="text" name="allergies" value={formData.allergies} onChange={handleChange} />
                                {errors.allergies && <span className='form-text error-text'>{errors.allergies}</span>}
                            </div>
                            <div className='form-text'>Kommer du på bröllopet?</div>
                            <div className='button-container'>
                                <button type="button" className={`circle-btn ${formData.coming ? 'active' : ''}`} onClick={handleFirstButtonClick} />
                                <div className='form-text'>Ja</div>
                                <button type="button" className={`circle-btn ${!formData.coming ? 'active' : ''}`} onClick={handleSecondButtonClick} />
                                <div className='form-text'>Nej</div>
                            </div>
                            <button type="submit" className='send-button'>Skicka</button>
                        </form>
                    </div>
                </div>
            </div>
            <AlertModal
                isOpen={showErrorAlert}
                title="Något gick fel"
                message="Det gick inte att spara din OSA. Vänligen försök igen."
                confirmText="OK"
                onConfirm={() => setShowErrorAlert(false)}
            />
            <AlertModal
                isOpen={showAlert}
                title="OSA inskickad"
                message={`OSA inskickad för ${submittedData?.firstname} ${submittedData?.surname}: ${submittedData?.email}`}
                confirmText="OK"
                onConfirm={() => setShowAlert(false)}
            />
        </div>
    );
}

export default OSA;
